import {useEffect, useState} from 'react';

import {
  installPwa,
  PwaInstallState,
  subscribePwaInstall,
} from '../utils/pwaInstall';

const initialState: PwaInstallState = {
  canUsePrompt: false,
  isInstalled: false,
  isIos: false,
  isMobile: false,
};

export const usePwaInstall = () => {
  const [state, setState] = useState<PwaInstallState>(initialState);

  useEffect(() => {
    return subscribePwaInstall(setState);
  }, []);

  return {
    ...state,
    install: installPwa,
  };
};
